var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNachhaltigkeit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-Nachhaltigkeit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18409",
    "data-name": "Rectangle 18409",
    width: 33.775,
    height: 26.206
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39706",
    "data-name": "Path 39706",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39708",
    "data-name": "Path 39708",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71361",
    "data-name": "Group 71361",
    transform: "translate(8.797 14.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71331",
    "data-name": "Group 71331",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35725",
    "data-name": "Path 35725",
    d: "M77.152,16.847c-.019.988-.068,1.9-.047,2.816A20.559,20.559,0,0,0,78,24.68c.238.858.066,1.314-.551,1.487-.571.16-.992-.176-1.234-.969a21.032,21.032,0,0,1-1-6.3A14.557,14.557,0,0,1,76,13.875a9.936,9.936,0,0,0,.25-3A9.719,9.719,0,0,1,81.83,2.206,18.918,18.918,0,0,1,88.862.278C90.915.107,92.981.088,95.041,0c.147-.006.295,0,.51,0-.147.34-.279.63-.4.925a48.938,48.938,0,0,0-1.972,6.728,42.337,42.337,0,0,1-1.6,5.078,7.718,7.718,0,0,1-5.966,4.889,13.838,13.838,0,0,1-8.125-.665c-.068-.027-.14-.046-.34-.11m.142-.526c.1-.208.162-.338.229-.463.508-.955.959-1.945,1.536-2.856a21.94,21.94,0,0,1,5.166-5.486c.876-.685,1.8-1.3,2.7-1.958.549-.4.688-.92.377-1.373a.9.9,0,0,0-1.392-.156c-.931.636-1.872,1.263-2.764,1.951a24.275,24.275,0,0,0-6.393,7.164.826.826,0,0,0-.133.524c.195.859.427,1.709.671,2.653",
    transform: "translate(-61.776 0)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35726",
    "data-name": "Path 35726",
    d: "M0,12.181a25.955,25.955,0,0,1,8.9-.729,8.922,8.922,0,0,1,5.435,2.393c.042.041.081.086.109.116L13.2,16.606c-.276-.207-.552-.447-.858-.637-.528-.328-1.065-.645-1.617-.931-.624-.322-1.133-.2-1.384.286-.27.522-.041,1.017.571,1.384a23.8,23.8,0,0,1,2,1.31,1.813,1.813,0,0,1,.758,1.827,27.97,27.97,0,0,0,.045,3.729c.007.218,0,.372-.259.417A8.829,8.829,0,0,1,8.1,23.807a5.542,5.542,0,0,1-3.126-2.441c-.805-1.345-1.558-2.727-2.244-4.137A33.644,33.644,0,0,0,0,12.181",
    transform: "translate(0 -9.3)",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNachhaltigkeit);
export default __webpack_public_path__ + "static/media/ic-Nachhaltigkeit.0ba2f621a49ed7567fb15bfb2916ff7f.svg";
export { ForwardRef as ReactComponent };